module.exports = __webpack_public_path__ + "static/media/boomwritericon.449d53d3.png";